import styled from 'styled-components';

export const Container = styled.div`
    width: 400px;
}
`;

export const ExpressionLine = styled.div`
    margin-top: 10px;
    display: flex;
    > input {
        margin-right: 3px;
    }
}
`;

export const DeleteButtonArea = styled.div`
    margin-left: 5px;
}
`;

export const AddButtonArea = styled.div`
    margin-top: 10px;
}
`;

export const SubmitButtonArea = styled.div`
width: 100%;
margin-top: 10px;
> button {
   width:100%;
}
}
`;
